<i18n src="@/lang/actions.json"></i18n>

<i18n>
    {
        "en": {
        },
        "ua": {
        },
        "ru": {
        }
    }
</i18n>
<template>
  <el-header class="actions">
    <el-row
      type="flex"
      class="row-bg"
      justify="space-between"
      style="width: 100%; align-items: center"
    >
      <el-button-group>
        <slot name="left-side"></slot>
      </el-button-group>
      <el-button-group v-if="$slots['middle-side']">
        <slot name="middle-side"></slot>
      </el-button-group>
      <el-button-group>
        <slot name="button-group">
          <el-button disabled type="primary">{{
            $t("actions.none")
          }}</el-button>
        </slot>
      </el-button-group>
    </el-row>
  </el-header>
</template>

<script>
export default {
  name: "HeaderActions"
};
</script>

<style scoped></style>
